import { createFileRoute } from '@tanstack/react-router';
import { LoginFormComponent } from '../components';

export interface LoginParams {
  username?: string;
  error?: string;
}

export const Route = createFileRoute('/')({
  validateSearch: (search: Record<string, unknown>): LoginParams => {
    return {
      username: (search.username as string) || '',
      error: (search.error as string) || undefined,
    };
  },
  component: Login,
});

function Login() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return <LoginFormComponent routerNavigate={navigate} username={search.username} error={search.error} />;
}
